import { render } from "./ChampionshipFeeds.vue?vue&type=template&id=528f4b0a&scoped=true"
import script from "./ChampionshipFeeds.vue?vue&type=script&lang=js"
export * from "./ChampionshipFeeds.vue?vue&type=script&lang=js"

import "./ChampionshipFeeds.vue?vue&type=style&index=0&id=528f4b0a&scoped=true&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528f4b0a"]])

export default __exports__